import * as React from 'react';
import styles from './index.less';
import FNoDataTip from '@/components/FNoDataTip';
import { history } from '@@/core/history';
import { FUtil, FI18n } from '@freelog/tools-lib';
import useUrlState from '@/hooks/useUrlState';

interface ErrorCommonProps {}

function ErrorCommon({}: ErrorCommonProps) {
  const [urlState] = useUrlState<{ tipText?: string; btnText?: string }>({
    tipText: FI18n.i18nNext.tAuto('msg_have_no_access'),
    btnText: '将前往首页',
  });

  return (
    <div>
      <FNoDataTip
        height={'calc(100vh - 70px)'}
        tipText={urlState.tipText}
        // btnText={urlState.btnText}
        // onClick={() => {
        //   history.replace(FUtil.LinkTo.market());
        // }}
      />
    </div>
  );
}

export default ErrorCommon;
